import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.JFXR,
  displayName: "Xray",
  isCustomerFacing: true,
};

export default entitlement;
